import { connect } from 'react-redux';

import ErrorMessage from '@/components/CommonTable/ErrorMessage';
import { retryFetch } from '@/features/purchaseHistoryPage/actions';

const mapDispatchToProps = { retry: retryFetch };

export default connect(null, mapDispatchToProps)(ErrorMessage);
